import React from "react";
import { PicturesContainer, Picture as StyledPicture, StyledWidePicture, WidePictureContainer } from "./Picture.styles";

interface PicturesProps {
    images: { src: string; alt: string }[];
}

export const Picture: React.FC<PicturesProps> = ({ images }) => {
    return (
        <PicturesContainer>
            {images.map((image, index) => (
                <StyledPicture key={index} src={image.src} alt={image.alt} />
            ))}
        </PicturesContainer>
    );
};



interface WidePictureProps {
    src: string;
    alt: string;
}

export const WidePicture: React.FC<WidePictureProps> = ({ src, alt }) => {
    return (
        <WidePictureContainer>
            <StyledWidePicture src={src} alt={alt} />
        </WidePictureContainer>
    );
};

